module.exports = __webpack_public_path__ + "static/media/step-6-anything.34a4b51e.gif";